import { AudioOutlined, CloseCircleOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import styles from "./SearchBar.module.css";
import { Alert, Button, Col, Input, Row, Space, Tag, Typography, Image } from "antd";
import { SearchProps } from "antd/es/input/Search";
import { useDispatch, useSelector } from "react-redux";
import askAiIcon from '../../Icons/NotableHQ AI Icon.jpeg'
import {
  fetchPublicCollections,
  setPage,
  setSearch,
} from "../../Slices/PublicCollectionsDataSlice";
import Marquee from "react-fast-marquee";
import Title from "antd/es/typography/Title";
import { useSearchParams } from "react-router-dom";
const {  Text } = Typography;

const { Search } = Input;

const suffix = (
  <AudioOutlined
    style={{
      fontSize: 16,
      color: "#1677ff",
    }}
  />
);

const SearchBar: React.FC = () => {
  const dispatch = useDispatch();
  const [invalidSearch, setInvalidSearch] = useState<any>(false);
  const collectionsLoader = useSelector(
    (state: any) => state.publicCollectionsData.collectionsLoader
  );
  
  // let searchParams:any = new URLSearchParams(window.location.search);

  const [searchParams, setSearchParams]:any = useSearchParams();
  const [searchInput, setSearchInput] = useState(searchParams.get('search'))
  const [isSearchParam, setIsSearchParam] = useState(searchParams.get('search'))
  const searchInputRef = useRef<any>({});

  
  useEffect(()=>{
    setSearchInput(searchParams.get('search'))
  }, [searchParams])


  // Function to remove search

  const removeSearch = ()=>{
    searchParams.delete('search');
    searchParams.delete('ai');
    searchParams.delete('page')
    searchParams.delete('sortBy')
    searchParams.delete('per_page')
    setSearchParams(searchParams)
    setSearchInput('');
    setIsSearchParam(false);
    setInvalidSearch(true);
    dispatch(fetchPublicCollections({page: searchParams.get('page'), search : searchParams.get('search'), sortBy : searchParams.get('sortby'), perPage : searchParams.get('per_page')}));
  }

  // const SearchResults = () => {
  //   const searchTerm = searchParams.get("search");
  //   return searchTerm;
  // };
  
  // let searchTerm:any = SearchResults();

  useEffect(()=>{
    setSearchInput(searchParams.get('search'))
    setIsSearchParam(searchParams.get('search') ? true : false)
  }, [searchParams.get('search')])


  const onSearch: SearchProps["onSearch"] = (searchValue) => {
    if (searchInput?.length === 0 || searchValue?.length === 0) {
      setInvalidSearch(true);
    } else if (searchValue){
      searchParams.set("search", searchValue);
      searchParams.delete('page')
      searchParams.delete('sortBy')
      searchParams.delete('per_page')
      setSearchParams(searchParams)
      setIsSearchParam(true)
      dispatch(fetchPublicCollections({page: searchParams.get('page'), search : searchParams.get('search'), sortBy : searchParams.get('sortBy'), perPage : searchParams.get('per_page'), aiSearch  : searchParams.get('ai')}));
    }
     else {
      removeSearch();
    }
  };

  const handleAISearch =()=>{
    if (searchInputRef.current.input.value?.length === 0){
      setInvalidSearch(true);
    }
    else{
      searchParams.set("ai", 'true');
      setSearchParams(searchParams)
      onSearch(searchInputRef.current?.input?.value);
    }
    
  }

  return (
    <>
      <Space className={styles.searchMain}  direction="vertical">
        <Space style={{width: "100%", justifyContent: "space-between"}} direction="horizontal">
        <Search
          className={styles.searchinput}
          placeholder={
            invalidSearch ? "Please Enter Something.." : "Search for a topic"
          }
          enterButton="Search"
          size="large"
          // suffix={suffix}
          // allowClear
          status={invalidSearch ? "warning" : undefined}
          onSearch={value => {
             searchParams.delete('ai')
             setSearchParams(searchParams)
            onSearch(value);
          }}
          value={searchInput}
          onChange={(e)=> setSearchInput(e.target.value)}
          defaultValue={searchInput}
          ref={searchInputRef}
        />
        <Button onClick={handleAISearch} style={{height: "40px", marginLeft: "5px", fontWeight: "500"}} icon={<Image onClick={handleAISearch} src={askAiIcon} height={20} width={20} preview={false} />}>ASK AI</Button>
        </Space>

      </Space>
    { isSearchParam ? <Row justify={'center'}><Text style={{fontWeight: "500", fontSize: "16px"}}>You've Searched for  </Text>  <Tag color="magenta" style={{marginLeft: "8px", fontSize: "16px"}} closeIcon={<CloseCircleOutlined />} onClose={removeSearch}>{searchParams.get('search')}</Tag></Row> : null }


    </>
  );
};

export default SearchBar;
